import {
  Component,
  HostBinding,
  HostListener,
  Injector,
  OnDestroy,
  OnInit,
  SkipSelf,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { IconSize } from '@freelancer/ui/icon';
import * as Rx from 'rxjs';
import { ModalService } from './modal.service';

export enum ModalSize {
  SMALL = 'small',
  MID = 'mid',
  LARGE = 'large',
}

@Component({
  selector: 'fl-modal',
  template: `
    <div class="ModalContainer"
      [attr.data-drawer]="isDrawer"
    >
      <div class="ModalDialog"
        [attr.data-size]="size"
        [attr.data-drawer]="isDrawer"
      >
        <div class="ModalContent">
          <fl-icon class="ModalCloseButton"
            *ngIf="!hideCloseButton"
            [name]="'ui-close'"
            [size]="IconSize.SMALL"
            (click)="handleEscape()"
          ></fl-icon>
          <ng-container #modalContent></ng-container>
        </div>
      </div>
      <div class="ModalBackdrop"
        [attr.data-backdrop]="backdropActive"
        (click)="handleClick()"
      ></div>
    </div>
  `,
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit, OnDestroy {
  readonly sizeDefault = ModalSize.LARGE;
  readonly hideCloseButtonDefault = false;
  readonly closeOnBackdropClickDefault = true;
  readonly isDrawerDefault = false;

  IconSize = IconSize;
  ModalSize = ModalSize;

  @ViewChild('modalContent', { read: ViewContainerRef })
  modalContent: ViewContainerRef;
  @HostBinding('class.IsActive') backdropActive = false;
  isDrawer = this.isDrawerDefault;

  // To be set by modal service at `open`
  size = this.sizeDefault;
  hideCloseButton = this.hideCloseButtonDefault;
  closeOnBackdropClick = this.closeOnBackdropClickDefault;

  openStreamSubscription: Rx.Subscription;

  constructor(
    private modalService: ModalService,
    @SkipSelf() private injector: Injector,
  ) {}

  ngOnInit() {
    this.modalService.setContainer(this.modalContent, this.injector);
    this.openStreamSubscription = this.modalService.openStream.subscribe(
      open => {
        this.backdropActive = !!open;
        // new modal being opened: read config from modalService
        if (open) {
          const {
            size = this.sizeDefault,
            hideCloseButton = this.hideCloseButtonDefault,
            closeOnBackdropClick = this.closeOnBackdropClickDefault,
            isDrawer = this.isDrawerDefault,
          } = this.modalService.getCurrentConfig();
          this.size = size;
          this.hideCloseButton = hideCloseButton;
          this.closeOnBackdropClick = closeOnBackdropClick;
          this.isDrawer = isDrawer;
        }
      },
    );
  }

  ngOnDestroy() {
    this.openStreamSubscription.unsubscribe();
  }

  handleClick() {
    if (this.closeOnBackdropClick) {
      this.modalService.close();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(e?: KeyboardEvent) {
    this.modalService.close();
  }
}
